import React from "react";
import { CSVLink, CSVDownload } from "react-csv";
import { Assessment3aFuelTypeInfo } from "../state";
import { Assessment3aVendorAssignedStatusEnum } from "../state";
import { Assessment3aFuelTypesStatusHolder } from "../state";

interface Assessment3aDownloadCSVProps {
    fuelTypes: Assessment3aFuelTypeInfo[];
}

function Assessment3aDownloadCSV({ fuelTypes }: Assessment3aDownloadCSVProps) {
    
    const csvData = [["Fuel", "Issue", "Action Plan"]];
        let rowIndex:number = 1;
        //iterate fuel types
        fuelTypes.map(fuel => {
            if(fuel.appIncludesVendorAndAcctNoDesc != null && fuel.appIncludesVendorAndAcctNoDesc != '')
            {
                csvData[rowIndex] = [fuel.description
                                      ,"The LIHEAP application should ask for the vendor and account number of all applicants. "
                                      , fuel.appIncludesVendorAndAcctNoDesc];
                rowIndex++; 
            }
            if(fuel.appVendorAndAcctNoRequiredFieldDesc != null && fuel.appVendorAndAcctNoRequiredFieldDesc != '')
            {
                csvData[rowIndex] = [fuel.description
                                      ,"The LIHEAP application should make clear that electric vendor and account number are required fields for all applicants."
                                      , fuel.appVendorAndAcctNoRequiredFieldDesc];
                rowIndex++; 
            }
            if(fuel.intakeFollowupMissingVendorDesc != null && fuel.intakeFollowupMissingVendorDesc != '')
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Staff at intake agencies should be instructed to follow up with all applicants who fail to provide vendors and account numbers."
                                      , fuel.intakeFollowupMissingVendorDesc];
                rowIndex++; 
            }
            if(fuel.vendorAssignmentStatus == Assessment3aVendorAssignedStatusEnum.Under95NotMeetTarget
                && fuel.otherReasonDesc != null
                && fuel.otherReasonDesc != '')
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Ideas about what might be causing the discrepancy."
                                      , fuel.otherReasonDesc];
                rowIndex++; 
            }                       
        });
    return (
      <CSVLink data={csvData} filename="ElectricBaseloadAssessment3a.csv" className="dataButton">Download as CSV</CSVLink>
    );
}
export default Assessment3aDownloadCSV;
